module.exports = __webpack_public_path__ + "static/media/supper1-1.eadc12b5.jpg";